export const authStore = {
    state: () => ({
        accessToken: ""
    }),
    getters: {
        getAccessToken: (state) => state.accessToken
    },
    mutations: {
        setAccessToken: (state, payload) => {
            state.accessToken = payload.accessToken
        }
    }
}
